import { mediaQueryUp } from 'components/utils/breakpoint'
import useLoyaltyConfig from 'loyalty/hooks/useLoyaltyConfig'
import { rem } from 'polished'
import styled from 'styled-components'
import LoyaltyTierRequirementCard from './LoyaltyTierRequirementCard'

const PROGRESSIVE_TIERS: Array<App.LoyaltyTierProgressive> = ['bronze', 'silver', 'gold', 'platinum']

const TierCards = styled.div`
  display: grid;
  gap: ${rem(12)};
  grid-template-columns: 1fr;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(${PROGRESSIVE_TIERS.length}, 1fr);
    gap: ${rem(16)};
  }
`

interface Props {
  /** When set, the matching tier card shows a "Your current tier" badge. Omit on logged-out views. */
  currentTier?: App.LoyaltyTier
}

/** The row of gradient tier cards (status credits + nights). Reused on the member and guest landing pages. */
function LoyaltyTierRequirementCards({ currentTier }: Props) {
  // Fetch (idempotently) and read the config so the cards render on any host page, not only ones
  // that happen to load the loyalty config elsewhere.
  const [config] = useLoyaltyConfig()
  const tierThresholds = config?.tierThresholds

  if (!tierThresholds) return null

  return (
    <TierCards>
      {PROGRESSIVE_TIERS.map(tier => <LoyaltyTierRequirementCard
        key={tier}
        tier={tier}
        threshold={tierThresholds[tier]}
        isCurrent={tier === currentTier}
      />)}
    </TierCards>
  )
}

export default LoyaltyTierRequirementCards
